import React from 'react';
import { components, MenuProps } from 'react-select';
import { Button } from '../../../Button/Button';
import { Box } from '../../../Box/Box';

export const Menu: React.FC<MenuProps<any, any>> = props => {
  const { selectProps, children } = props;

  const { onSelectAll, onUnselectAll } = selectProps;

  return (
    <>
      {(onSelectAll || onUnselectAll) && (
        <Box display="flex" justifyContent="space-between" px="16">
          <Box>
            {onSelectAll && (
              <Button variant="link" onClick={onSelectAll} size="small">
                Select All
              </Button>
            )}
          </Box>

          <Box>
            {onUnselectAll && (
              <Button variant="link" variantColor="neutral" onClick={onUnselectAll} size="small">
                Unselect All
              </Button>
            )}
          </Box>
        </Box>
      )}

      <components.Menu {...props}>{children}</components.Menu>
    </>
  );
};
